import type { ObjectId } from '@freightview/object-id'

import { type EquipmentType, equipmentTypes } from '../equipment/index.ts'
import {
  type WorkflowMarkup,
  workflowMarkupSchema,
} from '../models/account-user.ts'
import { type Workflow, workflows } from '../models/common.ts'
import {
  type VendorPermissionType,
  vendorPermissionTypes,
} from '../models/vendor.ts'
import {
  vArray,
  vEmail,
  vMinLength,
  vObject,
  vObjectId,
  vOptional,
  type vOutput,
  vPicklist,
  vPipe,
  vString,
} from '../validation/index.ts'

export interface AdminVendorOverview {
  _id: ObjectId
  name: string
  created: Date
  shipperAccountId: ObjectId
  permissions: VendorPermissionType[]
  workflows: Workflow[]
  equipmentOptions?: EquipmentType[]
  markup?: WorkflowMarkup
}

export const upsertVendorSchema = vObject({
  name: vString(),
  permissions: vArray(vPicklist(vendorPermissionTypes)),
  equipmentOptions: vOptional(
    vArray(vPicklist(equipmentTypes.map(e => e.key))),
  ),
  markup: vOptional(workflowMarkupSchema),
  workflows: vPipe(
    vArray(vPicklist(workflows)),
    vMinLength(1, 'Vendor requires at least one workflow'),
  ),
})
export type UpsertVendorAdminRequest = vOutput<typeof upsertVendorSchema>

export const createVendorUserSchema = vObject({
  email: vEmail,
  vendorId: vObjectId(),
})
export type CreateVendorUserRequest = vOutput<typeof createVendorUserSchema>

export const searchVendorSchema = vObject({
  search: vString(),
})
export type SearchVendorRequest = vOutput<typeof searchVendorSchema>

export type VendorSearchResult = {
  vendorId: ObjectId
  accountId: ObjectId
  vendorName: string
  accountName: string
  emailMatches?: string[]
}
